export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-8">移动端观看</h2>
        <div className="max-w-[640px] mx-auto bg-background-50 rounded-xl p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6">
          <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center flex-shrink-0">
            <i className="ri-smartphone-line text-background-50 text-3xl md:text-4xl"></i>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
              随时随地 · 手机追剧
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              桃花视频全面适配移动端浏览器，无需下载 App，打开即可观看高清影视内容。支持 iOS、Android 等主流系统，流量优化播放流畅不卡顿。
            </p>
            <a
              href="#index"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>浏览专题
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}